import { useEffect, useState } from "react";
import { LinearProgress } from "@mui/material";

import Modal from "../../Component/Modal/Modal";
import TextInput from "../../Component/UI/TextInput/TextInput";
import { validateBrandInput, validateProductInput } from "../../utils/helpers";
import Alert from "../../Component/UI/Alert/Alert";
import classes from "./UserKeyPlayer.module.css";

export default function UserKeyPlayer({ open, handleClose, handleConfirm, category, discoveryType }) {
  const [userKeyPlayer, setUserKeyPlayer] = useState("");
  const [isValidating, setIsValidating] = useState(false);
  const [isProductHasDifferentCategory, setIsProductHasDifferentCategory] =
    useState(false);
  const [productDomain, setProductDomain] = useState("");
  const [productVariants, setProductVariants] = useState([]);
  const [corrections, setCorrections] = useState("");

  async function checkIfInputValid() {
    setCorrections('');
    setIsValidating(true);
    setIsProductHasDifferentCategory(false);
    try {
      let response = await validateBrandInput(
        userKeyPlayer,
        category
      );
      setCorrections(response.data.correct_inputs[0]);
      setIsValidating(false);
      if (response.data.ans === "Yes") {
        setProductDomain(response.data.domain);
        setIsProductHasDifferentCategory(false);
      } else {
        setIsProductHasDifferentCategory(true);
        setIsValidating(false);
      }
    } catch (error) {
      console.log("Error while validating input");
      setIsValidating(false);
    }
  }

  async function checkIfProductValid() {
    setCorrections('');
    setIsValidating(true);
    setIsProductHasDifferentCategory(false);
    try {
      let response = await validateProductInput(
        userKeyPlayer,
        category
      );
      setIsValidating(false);
      setCorrections(response.data.correct_inputs[0]);
      if (response.data.ans === "Yes") {
        setProductDomain(response.data.domain);
        setIsProductHasDifferentCategory(false);
        const variants = response.data.variants || [];
        setProductVariants(
          variants.map((v) => ({
            id: v,
            name: v,
            display_name: v,
            active: true,
          }))
        );
      } else {
        setIsProductHasDifferentCategory(true);
        setIsValidating(false);
      }
    } catch (error) {
      console.log("Error while validating input", error);
      setIsValidating(false);
    }
  }

  useEffect(() => {
    if (!userKeyPlayer) return;
    let timer = setTimeout(() => {
      if (discoveryType === "product") {
        checkIfProductValid();
      } else {
        checkIfInputValid();
      }
    }, 1000);
    return () => {
      clearTimeout(timer);
    };
  }, [userKeyPlayer]);

  const placehodlerText =
    discoveryType === "product" ? "Enter Product Name" : "Enter Brand Name";

  return (
    <Modal
      title="Add Key Player"
      open={open}
      showActions
      handleClose={() => handleClose()}
      handleConfirm={() => {
        handleConfirm(userKeyPlayer, productDomain, productVariants);
      }}
      confirmBtnDisabled={!userKeyPlayer || isValidating}
    >
      <TextInput
        className={classes.input}
        fullWidth
        type="text"
        value={userKeyPlayer}
        onChange={(e) => setUserKeyPlayer(e.target.value)}
        placeholder={placehodlerText}
      />
      {corrections && (
        <span className={classes.hint_text}>
          Did you mean:
          <i
            className={classes.hint_chip}
            onClick={() => setUserKeyPlayer(corrections)}
          >
            {corrections}
          </i>
        </span>
      )}
      {isValidating && <LinearProgress />}
      {isProductHasDifferentCategory && (
        <div className="mt-3">
          <Alert
            title="Mismatched brand/product or category"
            message={
              <span>
                Please note, Entered brand/product doesn't belong to{" "}
                {category} category.
              </span>
            }
          />
        </div>
      )}
    </Modal>
  );
}
